import { ThemeOptions } from '@mui/material';

export const popperThemeOptions: ThemeOptions = {
  components: {
    MuiPopper: {
      defaultProps: {
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [0, -8],
            },
          },
        ],
      },
    },
  },
};
